const $inject = [
  "AdminPharmacistService",
  "MessageService",
  "$state",
  "$scope",
  "$rootScope",
  "data",
];

class PharmacistController {
  constructor(
    PharmacistService,
    MessageService,
    $state,
    $scope,
    $rootScope,
    data
  ) {
    this.PharmacistService = PharmacistService;
    this.$state = $state;
    this.$scope = $scope;
    this.data = data;
    $scope.data = data;

    this.backup();
    this.name_order = true;

    this.sort = {
      id: null,
      name: null,
      status: null,
    };

    $scope.search = {
      id: "",
      mrn: "",
      name: "",
      status: "",
    };
    this.set_view($scope, this.data.pharmacists);

    $scope.$watch("search", () => this.set_filtered_items(), true);

    this.sort_data();
  }

  set_view($scope, items, page_sizes = [10, 20, 50, 100, "All"]) {
    $scope.view = {
      page_sizes,
      per_page: null,

      current_page: 1,
      total_pages: null,

      start_item: 0,
      previous_item: 0,
      previous_total: items.length,
    };
    $scope.view.per_page = $scope.view.page_sizes[0];
    $scope.view.total_pages = Math.ceil(items.length / $scope.view.per_page);
  }

  backup() {
    this.original_data = angular.copy(this.data);
    let pharmacists = {};
    for (let pharmacist of this.original_data.pharmacists) {
      pharmacists[pharmacist.id] = pharmacist;
    }
    this.original_data.pharmacists = pharmacists;
    this.$scope.data = angular.copy(this.original_data);
  }

  sort_by(column) {
    switch (this.sort[column]) {
      case 1:
        this.sort[column] = -1;
        break;
      case -1:
        this.sort[column] = null;
        if (column === "name") {
          this.name_order = !this.name_order;
        }
        break;
      default:
        this.sort[column] = 1;
    }

    for (let key in this.sort) {
      if (key !== column) {
        this.sort[key] = null;
      }
    }

    this.sort_data();
  }

  sort_data() {
    let transform;
    let order;

    switch (true) {
      case this.sort.id !== null:
        transform = item => item.id;
        order = this.sort.id;
        break;
      case this.sort.mrn !== null:
        transform = item => item.mrnNumber;
        order = this.sort.mrn;
        break;
      case this.sort.name !== null:
        transform = item => this.full_name(item);
        order = this.sort.name;
        break;
      case this.sort.status !== null:
        transform = item => item.status.name;
        order = this.sort.status;
        break;
      default:
        transform = item => item;
        order = 0;
    }

    this.sorted = angular.copy(this.data);
    this.sorted.pharmacists.sort((a, b) => transform(a) > transform(b)? order: transform(a) < transform(b)? -order: 0);

    this.set_filtered_items();
  }

  sort_indicator(field) {
    switch (this.sort[field]) {
      case 1:
        return "fa-sort-asc";
      case -1:
        return "fa-sort-desc";
    }
    return "";
  }

  set_filtered_items() {
    this.$scope.data.pharmacists = this.sorted.pharmacists.filter(this.filter_by(this.$scope.search));
    this.set_total_pages();
  }

  filter_by(search) {
    let self = this;
    return function (value) {
      return self.string_search(search.id, value.id) &&
        self.string_search(search.mrn, value.mrnNumber) &&
        self.string_search(search.name, self.full_name(value)) &&
        self.string_search(search.status, value.status.name);
    };
  }

  full_name(pharmacist) {
    let names = [pharmacist.accountHolder.firstName, pharmacist.accountHolder.lastName].filter(name => name !== null);
    return this.name_order? names.join(" "): names.reverse().join(", ");
  }

  string_search(needle, haystack) {
    return String(haystack).replace(/\s+/, " ").toLowerCase().includes(String(needle).replace(/\s+/, " ").toLowerCase());
  }

  array_search(needles, haystack, transform = item => item) {
    return needles.every(needle => haystack.some(straw => transform(needle) === transform(straw)));
  }

  set_per_page(size) {
    this.$scope.view.per_page = size;
    this.set_total_pages();
  }

  set_total_pages() {
    this.$scope.view.total_pages = Math.ceil(this.$scope.data.pharmacists.length / this.$scope.view.per_page);
    this.set_current_page();
  }

  set_page(page) {
    this.$scope.view.previous_item = (page - 1) * this.$scope.view.per_page;
    this.$scope.view.previous_total = this.$scope.data.pharmacists.length;
    this.set_current_page();
  }

  set_current_page() {
    this.$scope.view.current_page = Math.floor(this.$scope.view.previous_item * this.$scope.data.pharmacists.length / this.$scope.view.previous_total / this.$scope.view.per_page) + 1;
    this.$scope.view.start_item = (this.$scope.view.current_page - 1) * this.$scope.view.per_page;
  }
}

PharmacistController.$inject = $inject;

export default PharmacistController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/pharmacist.controller.js
 **/